import { cloneElement, useEffect, useMemo } from "react";
import { useConstant } from "../useConstant/index.js";
import { subscribe, unsubscribe, useSources } from "./store.js";
function useWormhole(target, options = {}) {
  const { sortFn = defaultSortFn } = options;
  const wormholeId = useConstant(() => window.crypto.randomUUID());
  useEffect(() => {
    subscribe(target, wormholeId);
    return () => {
      unsubscribe(target, wormholeId);
    };
  }, [target, wormholeId]);
  const wormholes = useSources(target);
  return useMemo(
    () => wormholes.slice().sort(sortFn).reduce(
      (acc, wormhole) => {
        wormhole.worms.forEach((worm) => {
          const clone = cloneElement(worm, {
            key: `${wormhole.id}${worm.key}`
          });
          acc.worms.push(clone);
        });
        if (wormhole.meta) {
          acc.meta = Object.assign(acc.meta ?? {}, wormhole.meta);
        }
        return acc;
      },
      { worms: [], meta: void 0 }
    ),
    [sortFn, wormholes]
  );
}
function defaultSortFn(a, b) {
  return (a.priority ?? Number.POSITIVE_INFINITY) - (b.priority ?? Number.POSITIVE_INFINITY);
}
export {
  useWormhole
};
//# sourceMappingURL=useWormhole.js.map
